import {
  Card,
  Form,
  Row,
  DatePicker,
  Button,
  Statistic,
  Space,
  Divider,
} from 'antd'
import {
  SearchOutlined,
  ReloadOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import service from '../../../@services'
import PaymentTable from '../components/PaymentTable'
import * as Utils from '../../../@utils'
import AuthComponent from '../../../components/AuthComponent'
const { RangePicker } = DatePicker

/**
 * @param {Object} values 需要格式化的对象
 * @param {String} formatStr 格式化样式 默认'YYYY-MM-DD HH:mm:ss'
 * @returns Object
 */
const format = (values, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
  if (!values) return {}
  values.beginCreateTime = values.createTime
    ? values.createTime[0].startOf('day').format(formatStr)
    : null
  values.endCreateTime = values.createTime
    ? values.createTime[1].endOf('day').format(formatStr)
    : null
  return { ...values }
}
/**
 * @param onSearch 查询方法
 * @param onExport 导出方法
 *
 */
const PaymentForm = (props) => {
  const {
    onSearch = () => {},
    onExport = () => {},
    authKey = { search: '', export: '' },
  } = props
  const [form] = Form.useForm()
  const onFinish = (fieldsValue) => {
    let values = format(fieldsValue)
    onSearch({ ...values, pageIndex: 1 })
  }
  const onReset = () => {
    form.resetFields()
  }
  const handleExport = () => {
    let fieldsValue = form.getFieldValue()
    let values = format(fieldsValue)
    onExport(values)
  }
  return (
    <Card style={{ marginBottom: '15px' }}>
      <Form name="payment" layout="inline" form={form} onFinish={onFinish}>
        <Row>
          <Form.Item label="缴款单生成日期" name="createTime">
            <RangePicker allowClear placeholder={['开始日期', '结束日期']} />
          </Form.Item>
          <AuthComponent authKey={authKey.search}>
            <Form.Item>
              <Button
                ghost
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
              >
                查询
              </Button>
            </Form.Item>
          </AuthComponent>
          <Form.Item>
            <Button
              ghost
              type="primary"
              icon={<ReloadOutlined />}
              onClick={onReset}
            >
              重置
            </Button>
          </Form.Item>
          <AuthComponent authKey={authKey.export}>
            <Form.Item>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                导出
              </Button>
            </Form.Item>
          </AuthComponent>
        </Row>
      </Form>
    </Card>
  )
}
const Payment = (props) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({ pageIndex: 1, pageSize: 20 })
  const [summary, setSummary] = useState({})
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  /** 获取缴款单列表 */
  const getPayinDailyList = () => {
    setLoading(true)
    service.order
      .getPayinDailyList({ ...formData })
      .then((res) => {
        setLoading(false)
        let { recordCount, result, data } = res || {}
        setSummary(data || {})
        setTotal(recordCount || 0)
        setList(result || [])
      })
      .catch((e) => {
        setLoading(false)
      })
  }
  /** 查询 */
  const submit = (values) => {
    setFormData({ ...formData, ...values })
  }
  /** 导出 */
  const onExport = async (values) => {
    let file = await service.order.exportPayinDaily({
      ...formData,
      ...values,
    })
    const filename =
      '缴款单报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  useEffect(() => {
    getPayinDailyList()
  }, [formData])
  return (
    <div className="payment-page">
      <PaymentForm
        onSearch={submit}
        onExport={onExport}
        authKey={{
          search: '/payin/daily-payin/list',
          export: '/payin/daily-payin/export',
        }}
      />
      <Card>
        <Space
          className="total-box"
          size="large"
          split={<Divider type="vertical" />}
        >
          <Statistic title="缴款单金额(元)" value={summary.totalAmount || 0} />
          <Statistic
            title="已审核缴款单金额(元)"
            value={summary.verifiedAmount || 0}
          />
          <Statistic
            title="未审核缴款单金额(元)"
            value={summary.unverifiedAmount || 0}
          />
        </Space>
        <PaymentTable
          loading={loading}
          list={list}
          total={total}
          page={formData}
          submit={(pages = {}) => setFormData({ ...formData, ...pages })}
        />
      </Card>
    </div>
  )
}
export default Payment
